import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { FirstRunPageRoutingModule } from "./first-run-routing.module";
import { FirstRunPage } from "./first-run.page";
import { PushAcceptationPageModule } from "../../public/push-acceptation/push-acceptation.module";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { LoaderService } from "../../_services/loader.service";
import { HeaderModule } from "../../_component/header/header.module";
import { UserSettingsComponentModule } from "../_component/user-settings/user-settings.module";
import { FirstRunPushComponentModule } from "./first-run-push/first-run-push.module";
import { SwiperModule } from "swiper/angular";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    FirstRunPageRoutingModule,
    PushAcceptationPageModule,
    TranslateModule,
    UserSettingsComponentModule,
    FirstRunPushComponentModule,
    SwiperModule,
  ],
  declarations: [FirstRunPage],
  providers: [LoaderService],
})
export class FirstRunPageModule {}
